module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/mercadopago-logo.f9ae46a8.webp";